import React, { useEffect } from 'react';
import { CustomModalLayout, Loader } from '@wix/design-system';
import { reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useInstallerContext } from '../../context/InstallerContext';
import { CenteredSpinningLoader } from './CenteredSpinningLoader';

// this modal DOES NOT support translations
export const LoadingModal = () => {
  const {
    tenantId
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.loading);
  }, []);
  return tenantId ? /*#__PURE__*/React.createElement(CustomModalLayout, {
    width: "600px",
    height: "700px"
  }, /*#__PURE__*/React.createElement(CenteredSpinningLoader, null)) : /*#__PURE__*/React.createElement(Loader, null);
};
//# sourceMappingURL=LoadingModal.js.map